import { put, call, take, fork } from 'redux-saga/effects'
import { LLMGetChatsService } from '../../api/llm'
import { llmGetChatsSuccess } from '../../reducers/llm/action'
import { GET_CHATS } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getChatsFlow(payload) {
  try {
    const { applicationId, callback } = payload

    const response = yield call(LLMGetChatsService, applicationId)

    yield put(llmGetChatsSuccess(response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getChatsWatcher() {
  while (true) {
    const action = yield take(GET_CHATS)
    const { payload } = action

    yield fork(generalSaga, getChatsFlow, payload, false)
  }
}
